<template>
  <div class="wrapper">
    <div class="tabs-wrapper">
      <van-tabs class="tabs" v-model="active" :line-width="36" @click="redirect">
        <van-tab title="全部"></van-tab>
        <van-tab title="关注"></van-tab>
      </van-tabs>
      <!-- <div id="publish" @click="toPublish"> -->
        <i  id="publish" class="iconfont icon-xiangji" @click="toPublish"></i>
      <!-- </div> -->
    </div>
    <div class="viwe-wrapper">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>

import { Tab, Tabs } from "vant";

export default {
  data() {
    return {
      active: 0
    };
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  methods: {
    redirect(index) {
      let paths = ["/wxapp/circle/all", "/wxapp/circle/follow"];
      this.$router.replace(paths[index]);
    },
    toPublish() {
      // if (this.$isWeChat) {
      //   this.$router.push("/publish-we-chat");
      // } else {
        this.$router.push("/publish");
      // }
    }
  }
};
</script>

<style lang="less" scoped>
  

.tabs-wrapper {
  padding: 0 25vw 0;
  background-color: #fff;
  // border-bottom: 1px solid #f3f3f3;
  position: fixed;
  top: 55px;
  width: 100%;
  z-index: 996;
  #publish {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    z-index: 999;
    font-size: 18px;
  }
}
.viwe-wrapper {
  margin-top: 95px;
}
/deep/.van-tab {
  font-size: 14px;
  color: #2b2b2b;
}
/deep/.van-tabs__line {
  height: 0;
}
/deep/.van-tab--active {
  color: #e9aea8;
}
</style>